import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Popover,Position,
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";
import { Icon, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

class PressItem extends Component {
    
  render() {
    return (
        <li className="col press_item">
            <h5 className="press_title">  
              <a className="press_link" href={this.props.link} target="_blank">
              
                <Icon icon="document-open" iconSize={Icon.SIZE_LARGE} intent={Intent.PRIMARY} />
                {this.props.title}
                
                </a>
              </h5>

            <div className="press_date">{this.props.date}</div>
            <div className="press_teaser">{this.props.teaser}</div>
        </li>
    );
  }
}

export default PressItem;
